import * as React from 'react';
import './style.scss';
import classNames from 'classnames';
import { IGatsbyImageData, GatsbyImage } from 'gatsby-plugin-image';

interface Props {
  children?: any;
  lightCard?: boolean;
  className?: string;
  direction: 'up' | 'down';
  image?: IGatsbyImageData;
}

const WideCard: React.SFC<Props> = ({
  children,
  lightCard = false,
  className = '',
  direction,
  image,
}) => {
  return (
    <div
      className={classNames(
        'wide-card',
        `wide-card--${direction}${image ? '-image' : ''}`,
        direction === 'down' ? 'wide-card--bottom' : '',
        `wide-card--${image ? 'image' : 'card'}-height`
      )}
    >
      {children === undefined && image ? (
        <GatsbyImage
          alt=""
          image={image}
          className={classNames('wide-card__image-card', className)}
        />
      ) : (
        <div
          className={classNames('wide-card__card', className, {
            ['wide-card__card-light']: lightCard,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default WideCard;
